import * as React from "react";

import { SESSIONS_ROUTES } from "@constants";
import LoginPage from "./Login";
import LogoutPage from "./Logout";
import LoginHousePage from "./LoginHouse";

export const SessionRoutes = [{
	path: SESSIONS_ROUTES.LOGIN_URL,
    notRender: true,
    hideInHome: true,
	element: <LoginPage />
}, {
	path: SESSIONS_ROUTES.LOGIN_HOUSE_URL,
    notRender: true,
    hideInHome: true,
	element: <LoginHousePage />
}, {
	path: SESSIONS_ROUTES.LOGOUT_URL,
    notRender: true,
    hideInHome: true,
	element: <LogoutPage />
}]

